module.exports = __webpack_public_path__ + "img/img_32389_0_123.beb303b3.png";